module.exports = __webpack_public_path__ + "static/media/defaultMarkdown.3dcb5281.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Certificates/Contents/defaultMarkdown.md
// module id = 823
// module chunks = 0